<template>
  <div class="separator">
    <hr class="holes" />
  </div>
</template>

<script>
export default {
  name: 'Separator'
}
</script>

<style lang="scss" scoped>
.separator {
  position: relative;
  height: 2px;
  margin: 2.5em 0;
}

.holes {
  position: absolute;
  left: -1.5em;
  right: -1.5em;
  border: none;
  border-bottom: 3px dotted #918573;
  top: 0;
  margin: 0;
}
</style>
